import { createSlice } from "@reduxjs/toolkit";
import * as actions from './api';
import axios from 'axios';

export const lessonSlice = createSlice({
    name: 'lesson',
    initialState: {
        loading: false,
        error: null,
        list: [],
        form: null,
        popup: false,
    },
    reducers: {
        lessonsRequested: (state, action) => {
            state.loading = true;
        },
        lessonsReceived: (state, action) => {
            state.loading = false;
            const { data, courseId } = action.payload;
            const newLessons = data.map(lesson => ({ ...lesson, courseId }));

            const otherLessons = state.list.filter(l => l.courseId !== courseId);
            state.list = [...otherLessons, ...newLessons];
        },
        lessonsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        lessonRequested: (state, action) => {
            state.loading = true;
        },
        lessonCreated: (state, action) => {
            state.loading = false;
            state.popup = false;
            state.list = [action.payload, ...state.list];
            state.form = null;
        },
        lessonUpdated: (state, action) => {
            state.loading = false;
            state.popup = false;
            state.form = null;
            const index = state.list.findIndex(lesson => lesson.id === action.payload.id);
            state.list[index] = action.payload;
        },
        lessonDeleted: (state, action) => {
            state.loading = false;
            state.list = state.list.filter(lesson => lesson.id !== action.payload.id);
        },
        lessonError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        showLessonPopup: (state, action) => {
            state.popup = true;
            state.form = action.payload;
        },
        closePopup: (state, action) => {
            state.popup = false;
            state.form = null;
        }
    }
});

const {
    lessonsRequested,
    lessonsReceived,
    lessonsError,
    lessonRequested,
    lessonError,
    lessonCreated,
    lessonUpdated,
    lessonDeleted,
    showLessonPopup,
    closePopup,
} = lessonSlice.actions;

const getLessons = (courseId) => async (dispatch, getState) => {
    dispatch(lessonsRequested());
    try {
        // Use the correct API endpoint from OpenAPI spec
        const url = courseId ? `/app/courses/${courseId}/lessons` : '/app/lessons';
        const response = await axios.request({
            baseURL: `${process.env.REACT_APP_BASE_URL}/api/v1`,
            url: url,
            method: 'GET',
            headers: {
                'X-Api-Key': process.env.REACT_APP_APP_TOKEN
            }
        });
        dispatch(lessonsReceived({ data: response.data.data, courseId }));
    } catch (error) {
        dispatch(lessonsError({ error: error.message }));
    }
}

const createLesson = (image, data) => (dispatch, getState) => {
    const accessToken = getState().auth.accessToken;

    dispatch(
        actions.uploadCallBegan(
            {
                url: '/file/upload',
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                },
                data: image,
                onStart: lessonRequested.type,
                onSuccess: (imageResponse) => actions.apiCallBegan(
                    {
                        url: '/lessons',
                        method: 'POST',
                        headers: {
                            'Authorization': 'Bearer ' + accessToken
                        },
                        data: {
                            ...data,
                            imageId: imageResponse.id
                        },
                        onStart: lessonRequested.type,
                        onSuccess: lessonCreated.type,
                        onError: lessonError.type
                    }
                ),
                onError: lessonError.type
            }
        )
    );
}

const updateLesson = (image, data) => (dispatch, getState) => {
    const accessToken = getState().auth.accessToken;

    if (!image) {
        dispatch(
            actions.apiCallBegan(
                {
                    url: '/lessons/' + data.id,
                    method: 'PUT',
                    headers: {
                        'Authorization': 'Bearer ' + accessToken
                    },
                    data: data,
                    onStart: lessonRequested.type,
                    onSuccess: lessonUpdated.type,
                    onError: lessonError.type
                }
            )
        );
        return;
    }

    dispatch(
        actions.uploadCallBegan(
            {
                url: '/file/upload',
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                },
                data: image,
                onStart: lessonRequested.type,
                onSuccess: (imageResponse) => actions.apiCallBegan(
                    {
                        url: '/lessons/' + data.id,
                        method: 'PUT',
                        headers: {
                            'Authorization': 'Bearer ' + accessToken
                        },
                        data: {
                            ...data,
                            imageId: imageResponse.id
                        },
                        onStart: lessonRequested.type,
                        onSuccess: lessonUpdated.type,
                        onError: lessonError.type
                    }
                ),
                onError: lessonError.type
            }
        )
    );
}

const deleteLesson = (data) => (dispatch, getState) => {
    const accessToken = getState().auth.accessToken;

    dispatch(
        actions.apiCallBegan(
            {
                url: '/lessons/' + data.id,
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                },
                onStart: lessonRequested.type,
                onSuccess: lessonDeleted.type,
                onError: lessonError.type
            }
        )
    );
}

export {
    getLessons,
    createLesson,
    updateLesson,
    deleteLesson,
    showLessonPopup,
    closePopup
};

export default lessonSlice.reducer;